import { render, staticRenderFns } from "./studentQues.vue?vue&type=template&id=8a8be69e&scoped=true"
import script from "./studentQues.vue?vue&type=script&lang=js"
export * from "./studentQues.vue?vue&type=script&lang=js"
import style0 from "./studentQues.vue?vue&type=style&index=0&id=8a8be69e&prod&scoped=true&lang=less"
import style1 from "./studentQues.vue?vue&type=style&index=1&id=8a8be69e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8be69e",
  null
  
)

export default component.exports